import { render, staticRenderFns } from "./practiceResult.vue?vue&type=template&id=34a15afa"
import script from "./practiceResult.js?vue&type=script&lang=js&external"
export * from "./practiceResult.js?vue&type=script&lang=js&external"
import style0 from "./practiceResult.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "../../less/publicStyle.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports